import React from 'react';
import {
    Grid,
    Typography,
    Button,
    Pagination,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Box,
    IconButton
} from '@mui/material';

import FolderIcon from '@mui/icons-material/Folder';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import ViewColumnIcon from '@mui/icons-material/ViewColumn';
import SearchIcon from '@mui/icons-material/Search';
import AddIcon from '@mui/icons-material/Add';
import { useNavigate, useLocation } from 'react-router-dom';


import { SubHeader } from '../../utils/componentes-utiles/SubHeader';

export const Carpetas = () => {



    const navigate = useNavigate();
    const location = useLocation();

    const isActive = (path) => location.pathname === path;





    return (
        <Grid container direction="column" size={{ xs: 12 }}>

            {/* HEADER */}
            <Grid item size={{ xs: 12 }}>
                <SubHeader titulo="Documentación" />
            </Grid>

            {/* TABS */}
            <Grid
                container
                spacing={2}
                sx={{ px: 2, pb: 2 }}
                alignItems="center"
            >
                <Button
                    variant="text"
                    onClick={() => navigate('/personas')}
                    sx={{
                        fontWeight: isActive('/personas') ? 600 : 400,
                        borderBottom: isActive('/personas')
                            ? '2px solid'
                            : '2px solid transparent',
                        borderRadius: 0
                    }}
                >
                    Personas
                </Button>

                <Button
                    variant="text"
                    onClick={() => navigate('/carpetas')}
                    sx={{
                        fontWeight: isActive('/carpetas') ? 600 : 400,
                        borderBottom: isActive('/carpetas')
                            ? '2px solid'
                            : '2px solid transparent',
                        borderRadius: 0
                    }}
                >
                    Carpetas
                </Button>

                <Button
                    variant="text"
                    onClick={() => navigate('/documentacion')}
                    sx={{
                        fontWeight: isActive('/documentacion') ? 600 : 400,
                        borderBottom: isActive('/documentacion')
                            ? '2px solid'
                            : '2px solid transparent',
                        borderRadius: 0
                    }}
                >
                    Documentos
                </Button>
            </Grid>

            {/* ACCIONES */}
            <Grid
                container
                justifyContent="space-between"
                alignItems="center"
                sx={{ px: 2, pb: 2 }}
                gap={2}
            >
                <Grid container spacing={1} size={{ xs: 12, md: 'auto' }}>

                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            border: '1px solid',
                            borderColor: 'divider',
                            borderRadius: 1,
                            px: 1.5,
                            py: 0.5,
                            width: { xs: '100%', md: 260 }
                        }}
                    >
                        <SearchIcon fontSize="small" sx={{ mr: 1 }} />
                        <Typography variant="body2" color="text.secondary">
                            Búsqueda avanzada
                        </Typography>
                    </Box>

                    <Button size="small" variant="outlined">Estado</Button>
                    <Button size="small" variant="outlined">Tipo</Button>
                </Grid>

                <Grid container spacing={1} size={{ xs: 12, md: 'auto' }}>
                    <Button variant="outlined" startIcon={<FilterAltIcon />}>Filtros</Button>
                    <Button variant="outlined" startIcon={<FileDownloadIcon />}>Exportar</Button>
                    <Button variant="outlined" startIcon={<ViewColumnIcon />}>Columnas</Button>
                    <Button variant="outlined" startIcon={<AddIcon />}>Nueva Carpeta</Button>
                </Grid>
            </Grid>

            {/* SCROLL MOBILE */}
            <Grid
                sx={{
                    width: '100%',
                    overflowX: 'auto'
                }}
            >
                <Grid
                    container
                    direction="column"
                    sx={{
                        minWidth: { xs: 700, md: 900 }
                    }}
                >

                    {/* HEADER TABLA */}
                    <Grid
                        container
                        alignItems="center"
                        sx={{
                            px: 2,
                            py: 1,
                            bgcolor: 'grey.100',
                            borderTop: '1px solid',
                            borderBottom: '1px solid',
                            borderColor: 'divider'
                        }}
                    >
                        <Grid item size={{ xs: 0.6 }} />
                        <Grid item size={{ xs: 4 }}>Nombre</Grid>
                        <Grid item size={{ xs: 2 }}>Tipo</Grid>
                        <Grid item size={{ xs: 2.5 }}>Fecha</Grid>
                        <Grid item size={{ xs: 2.4 }}>Asociaciones</Grid>
                        <Grid item size={{ xs: 0.5 }} />
                    </Grid>

                    {/* FILAS */}
                    {[1, 2, 3, 4].map(row => (
                        <Grid
                            key={row}
                            container
                            alignItems="center"
                            sx={{
                                px: 2,
                                py: 1,
                                borderBottom: '1px solid',
                                borderColor: 'divider',
                                '&:hover': { bgcolor: 'action.hover' }
                            }}
                        >
                            <Grid item size={{ xs: 0.6 }}>
                                <IconButton size="small">
                                    <MoreVertIcon fontSize="small" />
                                </IconButton>
                            </Grid>

                            <Grid
                                item
                                size={{ xs: 4 }}
                                sx={{ display: 'flex', alignItems: 'center', gap: 1 }}
                            >
                                <FolderIcon color="primary" fontSize="small" />
                                <Typography variant="body2" noWrap>
                                    Carpeta ejemplo {row}
                                </Typography>
                            </Grid>

                            <Grid item size={{ xs: 2 }}>
                                <Typography variant="body2">General</Typography>
                            </Grid>

                            <Grid item size={{ xs: 2.5 }}>
                                <Typography variant="body2">01/01/2024</Typography>
                            </Grid>

                            <Grid item size={{ xs: 2.4 }}>
                                <Typography
                                    variant="body2"
                                    color="primary"
                                    noWrap
                                    sx={{ cursor: 'pointer' }}
                                >
                                    Prueba
                                </Typography>
                            </Grid>

                            <Grid item size={{ xs: 0.5 }} />
                        </Grid>
                    ))}
                </Grid>
            </Grid>

            {/* PAGINACIÓN */}
            <Grid
                container
                justifyContent="space-between"
                alignItems="center"
                sx={{ px: 2, py: 2 }}
                gap={2}
            >
                <FormControl variant="standard" sx={{ minWidth: 120 }}>
                    <InputLabel>Filas por página</InputLabel>
                    <Select value={25}>
                        <MenuItem value={25}>25</MenuItem>
                        <MenuItem value={50}>50</MenuItem>
                        <MenuItem value={100}>100</MenuItem>
                    </Select>
                </FormControl>

                <Pagination count={5} color="primary" />
            </Grid>
        </Grid>
    );
};
